$(document).ready(function () {
  $(".promotion-slider").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    dots: false,
    arrows: false,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });
});

// Slide to the relevant menu collection
document.querySelectorAll(".promotion-slider .card-list").forEach((link) => {
  link.addEventListener("click", function (event) {
    event.preventDefault();
    const targetTitle = this.getAttribute("title");
    const targetBlock = document.getElementById(targetTitle);

    if (targetBlock) {
      targetBlock.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  });
});
